<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo">RECRUIT</span>
                <span class="series-PageTitle_Title" style="color:#FFF">採用情報</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/recruit/RECRUIT.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner">
              <div class="st-Grid_Inner p-0 recruit-index-appear-1" data-appear="true">
                <h2 class="common-text-appear text-center recruit-index-appear-2" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>募集要項</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="company-Profile_List recruit-index-appear-3 mt-8 pt-6" data-appear="true">
                <dl>
                  <dt>募集職種</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">プロジェクトマネージャー(PM)／プロジェクトリーダー(PL)<br />
                        システムエンジニア(SE)／プログラマー(PG)</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>勤務地</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">東京都内及びその周辺地域</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>雇用形態</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">正社員、契約社員</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>給与</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">200,000～600,000円<br />
                        ※給与は経験・能力等を考慮し決定致します。</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>勤務時間</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">
                        ・週休2日制、有給休暇／夏季休暇／産前産後休暇／特別休暇／慶弔休暇／育児休暇／介護休暇
                        <br />・健康保険、厚生年金保険、雇用保険、労災保険完備
                      </p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>選考方法</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">履歴書、職務経歴書による審査及び面接</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>応募方法</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">
                        履歴書(フリーフォーマット)および職務経歴書に日本語で記入した上、弊社の 採用応募における個人情報の取扱い をご同意いただけた場合のみ、下記の送信先に送信してください。
                        <br />送信先: recruit@roboticsolutions.co.jp
                        <br />選考通過者には、メールまたは電話にて面接日の調整をさせていただきます。
                        <br />合否に関わらず一週間以内に選考の結果をご連絡いたします。
                      </p>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <router-link class="st-BreadcrumbsList_Item-link" to="/" itemprop="item">ホーム</router-link>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">採用情報</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {

      $(".series-PageTitle_Inner").eq(0).addClass('appear')
      $('.recruit-index-appear-1').addClass('st-Grid_Inner_appear')
      $('.recruit-index-appear-2').addClass('appear')
      $('.recruit-index-appear-3').addClass('appear')

      $(document).scroll(() => {

        if (this.$route.path != '/recruit/index') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()

        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (scroH > 300) {
          $('.series-PageTitle_Inner').eq(0).removeClass('appear')
        } else {
          $('.series-PageTitle_Inner').eq(0).addClass('appear')
        }

        if (scroH > 700) {
          $('.recruit-index-appear-1').removeClass('st-Grid_Inner_appear')
          $('.recruit-index-appear-2').removeClass('appear')
        } else {
          $('.recruit-index-appear-1').addClass('st-Grid_Inner_appear')
          $('.recruit-index-appear-2').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/recruit.css">
</style>



// WEBPACK FOOTER //
// src/components/pages/recruit/recruit.vue